export default __webpack_public_path__ + "static/Archie-bc51e7c558b27951c706396dade141a4.jpeg";